import { getAuth, signOut } from 'firebase/auth';
import store from '../store/store.ts';
import { removeUser } from '../store/slices/userSlice';
import { disconnectSocket } from './socketManager';

export function isAuthError(error) {
  if (!error?.response) return false;
  const status = error.response.status;
  return status === 401 || status === 403;
}

export async function handleLogout() {
  disconnectSocket();
  const auth = getAuth();
  await signOut(auth);
  store.dispatch(removeUser());
}
